import { render } from "./shipping-dropdown.vue?vue&type=template&id=1cd74c63"
import script from "./shipping-dropdown.vue?vue&type=script&lang=js"
export * from "./shipping-dropdown.vue?vue&type=script&lang=js"

import "./shipping-dropdown.vue?vue&type=style&index=0&id=1cd74c63&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__